<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Volume"> <div class="title-block" id="rw-title-block_108532-00001"><h1><a href="#/9781847675705_tableofcontents"><i>The Story of My Boyhood and Youth</i></a></h1></div> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675705_volume_01.vue?3a20195c